export default __webpack_public_path__ + "static/christophe_broillet-443a8e12008b4adcf4dc406b11bdd37c.png";